// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__hBQBU","itemTitle":"ClientEmergencyInfo_itemTitle__1snyv","itemText":"ClientEmergencyInfo_itemText__2gbsV"};